module.exports = __webpack_public_path__ + "static/media/travel12.88e009a6.jpg";